import { render, staticRenderFns } from "./VehicleOnMap.vue?vue&type=template&id=5062af8c&lang=pug&"
import script from "./VehicleOnMap.vue?vue&type=script&lang=ts&"
export * from "./VehicleOnMap.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleOnMap.vue?vue&type=style&index=0&id=5062af8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports